import { render, staticRenderFns } from "./EditIcon2.vue?vue&type=template&id=357ceaa7"
import script from "./EditIcon2.vue?vue&type=script&lang=js"
export * from "./EditIcon2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports